/* eslint-disable react/jsx-key */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { Component } from 'react';
import { HotKeys } from 'react-hotkeys';
import Loading from '../../Loading';
import Checkbox from '../../Checkbox';
import Popover from '../../Popover';
import Tooltip from '../../Tooltip';
import Dnd from '../../Dnd';

import { executeEnterEvent, countTitle } from '../utils';
import { findParentTd, getSysFieldid, toast } from '@platform/api';
import ReactDOM from 'react-dom';

export default class ReferDropDown extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentIndex: 0,
            configNamesList: [],
            dargname: '',
            currentColumnConfigIndex: -1,
            dragoverIndex: -1,
            closeColumn: true,
        };
        this.time = 0;
        this.firstSelectedData = [];
        this.firstHistoryData = [];
        this.firstSearchData = [];
    }

    componentWillUnmount() {
        this.referScroll = null;
        this.lifecycleStatus = 'unmount';
    }

    componentWillMount() {
        this.lifecycleStatus = 'mount';
    }
    componentDidMount() {
        this.props.onRef && this.props.onRef(this);
    }

    //WARNING! To be deprecated in React v17. Use new lifecycle static getDerivedStateFromProps instead.
    componentWillReceiveProps(nextProps) {
        if (!nextProps.dropDownShow || !nextProps.data.length) {
            this.setState({ currentIndex: 0 });
        }
    }

    handleColumnConfig = (columnConfig) => {
        this.props.updateColumnConfig(columnConfig);
    };

    handleColumnConfigPop = (ColumnConfigPopFlag) => {
        this.props.updateColumnConfigPop(ColumnConfigPopFlag);
    };

    render() {
        let {
            columnConfig,
            showColumnConfigPop,
            allowColumnConfig,
            refType,
            jsonInsideRefer,
            type,
            treeConfig,
            closeColumnProps,
        } = this.props;

        // if (
        //     treeConfig &&
        //     treeConfig.name &&
        //     treeConfig.name[0] === '名称' &&
        //     treeConfig.name.length === 1
        // ) {
        //     treeConfig.name[0] = (jsonInsideRefer || {})[
        //         'containers-refer-0039'
        //     ];
        // }

        let {
                configNamesList,
                dargname,
                currentColumnConfigIndex,
                closeColumn,
            } = this.state,
            {
                name: names,
                code: codes,
                checked = {},
            } = refType === 'tree' ? treeConfig : columnConfig[0];
        // names = [...new Set(names)];
        // codes = [...new Set(codes)];

        // if (!closeColumnProps) {
        //     closeColumn = closeColumnProps;
        // }
        configNamesList =
            configNamesList.length === 0 ? [...names] : [...configNamesList];

        // if (
        //     !(
        //         allowColumnConfig &&
        //         refType !== 'tree' &&
        //         Array.isArray(configNamesList) &&
        //         configNamesList.length > 3
        //     )
        // ) {
        //     return <span>hh</span>;
        // }
        const list = configNamesList.map((e, i) => {
            let code = codes[i];
            if (checked[code] === undefined) {
                checked[code] = true;
            }
            return (
                <div
                    name={e}
                    code={code}
                    key={code}
                    fieldid={getSysFieldid(code)}
                    onMouseOver={() => {
                        this.setState({ currentColumnConfigIndex: i });
                    }}
                    onMouseLeave={() => {
                        this.setState({ currentColumnConfigIndex: -1 });
                    }}
                    className={`${
                        currentColumnConfigIndex === i &&
                        'refer-column-config-hover'
                    } ${
                        configNamesList.length <= 2 &&
                        (refType === 'tree' || type === 'dropDown') &&
                        'refer-column-disabled'
                    } ${
                        this.columnConfigFlag &&
                        dargname === e &&
                        'refer-column-disabled'
                    } ${this.state.dragoverIndex === i && 'refer-drag-over'}`}
                >
                    {/* <Checkbox
                    onClick={(evt) => {
                        evt.stopPropagation();
                        checked[code] === false
                            ? (checked[code] = true)
                            : (checked[code] = false);
                        columnConfig[0].checked = checked;
                        this.setState({ columnConfig }, () => {
                            this.pushToColumnConfig();
                        });
                    }}
                    checked={(checked || {})[code] !== false}
                    // disabled={names.length <= 2 ? true : false}
                >
                    <span title={e}>{e}</span>
                </Checkbox> */}
                    <span>
                        <span className="iconfont icon-tuozhuai1 column-config-tuozhuai"></span>
                        {checked[code] === false ? (
                            <React.Fragment>
                                <span
                                    className="iconfont icon-lieshezhi-yincang"
                                    onClick={(evt) => {
                                        evt.stopPropagation();
                                        //两列的时候点击没反应
                                        // if (configNamesList.length <= 2) {
                                        //     return;
                                        // }
                                        checked[code] === false
                                            ? (checked[code] = true)
                                            : (checked[code] = false);
                                        columnConfig[0].checked = checked;
                                        this.handleColumnConfig(columnConfig);
                                        this.props.pushToColumnConfig?.();
                                        this.setState({
                                            configNamesList: [
                                                ...columnConfig[0].name,
                                            ],
                                        });

                                        // this.setState({ columnConfig }, () => {
                                        //     this.pushToColumnConfig();
                                        // });
                                    }}
                                ></span>
                                <span
                                    title={e}
                                    className="refer-column-config-yincang"
                                >
                                    <Tooltip
                                        placement="top"
                                        overlay={e}
                                        delayHide={1}
                                        delayShow={1000}
                                        overlayStyle={{ zIndex: 2000 }}
                                    >
                                        <span>{e}</span>
                                    </Tooltip>
                                </span>
                            </React.Fragment>
                        ) : (
                            <React.Fragment>
                                <span
                                    className="iconfont icon-lieshezhi-xianshi"
                                    onClick={(evt) => {
                                        evt.stopPropagation();
                                        //两列的时候点击没反应
                                        // if (configNamesList.length <= 2) {
                                        //     return;
                                        // }
                                        if (
                                            Object.values(checked).filter(
                                                (item) => {
                                                    return item !== false;
                                                }
                                            ).length <= 1
                                        ) {
                                            toast({
                                                color: 'warning',
                                                content: '至少保留一个字段',
                                            });
                                            return;
                                        }
                                        checked[code] === false
                                            ? (checked[code] = true)
                                            : (checked[code] = false);
                                        columnConfig[0].checked = checked;

                                        this.handleColumnConfig(columnConfig);
                                        this.props.pushToColumnConfig?.();
                                        this.setState({
                                            configNamesList: [
                                                ...columnConfig[0].name,
                                            ],
                                        });

                                        // this.setState({ columnConfig }, () => {
                                        //     this.pushToColumnConfig();
                                        // });
                                    }}
                                ></span>
                                <span
                                    className="refer-column-config-xinshi"
                                    // title={e}---替换为toolTips
                                >
                                    <Tooltip
                                        placement="top"
                                        overlay={e}
                                        delayHide={1}
                                        delayShow={1000}
                                        overlayStyle={{ zIndex: 2000 }}
                                    >
                                        <span>{e}</span>
                                    </Tooltip>
                                </span>
                            </React.Fragment>
                        )}
                    </span>

                    {currentColumnConfigIndex === i && (
                        <span className="refer-column-zhi">
                            {i !== 0 && (
                                <Tooltip
                                    placement="top"
                                    overlay={
                                        jsonInsideRefer['containers-refer-0001']
                                    }
                                    delayHide={1}
                                    delayShow={1000}
                                    overlayStyle={{ zIndex: 2000 }}
                                >
                                    <span
                                        className={`refer-column-config-opt iconfont icon-zhiding ${
                                            i === 0 &&
                                            'refer-column-config-disabled'
                                        } ${
                                            configNamesList.length <= 2 &&
                                            (refType === 'tree' ||
                                                type === 'dropDown') &&
                                            'refer-column-disabled'
                                        } ${
                                            currentColumnConfigIndex === i &&
                                            'refer-column-config-top-hover'
                                        }`}
                                        onClick={(evt) => {
                                            evt.stopPropagation();
                                            if (i !== 0) {
                                                columnConfig[0].name.splice(
                                                    i,
                                                    1
                                                );
                                                columnConfig[0].code.splice(
                                                    i,
                                                    1
                                                );
                                                columnConfig[0].name.unshift(e);
                                                columnConfig[0].code.unshift(
                                                    code
                                                );
                                                // this.setState(
                                                //     { columnConfig },
                                                //     () => {
                                                //         this.pushToColumnConfig();
                                                //     }
                                                // );
                                                this.setState({
                                                    configNamesList: [
                                                        ...columnConfig[0].name,
                                                    ],
                                                });
                                                this.handleColumnConfig(
                                                    columnConfig
                                                );
                                                this.props.pushToColumnConfig?.();
                                            }
                                        }}
                                    >
                                        {/* 置顶 */}
                                        {/* {this.state.jsonInsideRefer['containers-refer-0001']} */}
                                    </span>
                                </Tooltip>
                            )}
                            {i !== codes.length - 1 && (
                                <Tooltip
                                    placement="top"
                                    overlay={
                                        jsonInsideRefer['containers-refer-0004']
                                    }
                                    delayHide={1}
                                    delayShow={1000}
                                    overlayStyle={{ zIndex: 2000 }}
                                >
                                    <span
                                        className={`refer-column-config-opt iconfont icon-zhidi 
                                ${
                                    i === codes.length - 1 &&
                                    'refer-column-config-disabled'
                                } ${
                                            currentColumnConfigIndex === i &&
                                            'refer-column-config-bottom-hover'
                                        }`}
                                        onClick={(evt) => {
                                            evt.stopPropagation();
                                            if (i !== codes.length - 1) {
                                                columnConfig[0].name.splice(
                                                    i,
                                                    1
                                                );
                                                columnConfig[0].code.splice(
                                                    i,
                                                    1
                                                );
                                                columnConfig[0].name.push(e);
                                                columnConfig[0].code.push(code);
                                                // this.setState(
                                                //     { columnConfig },
                                                //     () => {
                                                //         this.pushToColumnConfig();
                                                //     }
                                                // );

                                                this.setState({
                                                    configNamesList: [
                                                        ...columnConfig[0].name,
                                                    ],
                                                });

                                                this.handleColumnConfig(
                                                    columnConfig
                                                );
                                                this.props.pushToColumnConfig?.();
                                            }
                                        }}
                                    >
                                        {/* 置底 */}
                                        {/* {this.state.jsonInsideRefer['containers-refer-0004']} */}
                                    </span>
                                </Tooltip>
                            )}
                        </span>
                    )}

                    {/* <span
                    className={`refer-column-config-opt ${
                        i === 0 && 'refer-column-config-disabled'
                    }`}
                    onClick={(evt) => {
                        evt.stopPropagation();
                        if (i !== 0) {
                            columnConfig[0].name.splice(i, 1);
                            columnConfig[0].code.splice(i, 1);
                            columnConfig[0].name.splice(i - 1, 0, e);
                            columnConfig[0].code.splice(i - 1, 0, code);
                            this.setState({ columnConfig }, () => {
                                this.pushToColumnConfig();
                            });
                        }
                    }}
                >
                    
                </span>
                <span
                    className={`refer-column-config-opt ${
                        i === codes.length - 1 &&
                        'refer-column-config-disabled'
                    }`}
                    onClick={(evt) => {
                        evt.stopPropagation();
                        if (i !== codes.length - 1) {
                            columnConfig[0].name.splice(i, 1);
                            columnConfig[0].code.splice(i, 1);
                            columnConfig[0].name.splice(i + 1, 0, e);
                            columnConfig[0].code.splice(i + 1, 0, code);
                            this.setState({ columnConfig }, () => {
                                this.pushToColumnConfig();
                            });
                        }
                    }}
                >
                    
                </span> */}
                </div>
            );
        });
        return (
            <Popover
                className={`popover-in-refer coulmn-popover ${
                    refType === 'tree' && 'aband-mouse'
                }`}
                trigger="click"
                placement="bottom"
                // container={this.popover ? this.popover : null}
                // style={{ display: showColumnConfigPop ? 'unset' : 'none' }}
                // show={showColumnConfigPop}
                // onHide={() => {
                //     // if (this.flag) {
                //     //     this.flag = false;
                //     //     return;
                //     // }
                //     this.handleColumnConfigPop(false);
                // }}
                content={
                    closeColumn && (
                        <div
                            className="refer-popover-container"
                            fieldid={getSysFieldid('column-config_list')}
                            style={{
                                pointerEvents: refType === 'tree' && 'none',
                                cursor: refType === 'tree' && 'not-allowed',
                            }}
                        >
                            <div className="column-config-title">
                                <span className="column-config-title-name">
                                    {
                                        jsonInsideRefer[
                                            'containers-refer-column-setting'
                                        ]
                                    }
                                </span>
                            </div>
                            <div
                                // style={{ flex: '1 1 auto', overflow: 'auto' }}
                                // className="refer-config-column-scroll"
                                className={`refer-config-column-scroll ${
                                    list.length <= 8 &&
                                    'refer-column-del-scrolly'
                                }`}
                            >
                                <Dnd
                                    dragClass="refer-column-config-item"
                                    dropClass="refer-dnd refer-column-config-list"
                                    dragingClass="refer-column-config-item-darging"
                                    // dropOverClass="refer-drag-over"
                                    list={list}
                                    onStart={(drag, list) => {
                                        if (list) {
                                            this.columnConfigFlag = true;
                                            let dragColumnConfig = [
                                                ...columnConfig,
                                            ];

                                            dragColumnConfig[0].name = list.map(
                                                (e) => e.props.name
                                            );
                                            dragColumnConfig[0].code = list.map(
                                                (e) => e.props.code
                                            );
                                            let addIndex = drag.source.index;
                                            this.addIndex = addIndex;
                                            let dargname =
                                                dragColumnConfig[0].name[
                                                    addIndex
                                                ];
                                            // dragColumnConfig[0].name.splice(
                                            //     addIndex,
                                            //     0,
                                            //     dragColumnConfig[0].name[
                                            //         addIndex
                                            //     ]
                                            // );
                                            // dragColumnConfig[0].code.splice(
                                            //     addIndex,
                                            //     0,
                                            //     dragColumnConfig[0].code[
                                            //         addIndex
                                            //     ]
                                            // );

                                            this.setState({
                                                configNamesList: [
                                                    ...dragColumnConfig[0].name,
                                                ],
                                                dargname,
                                            });

                                            // this.setState(
                                            //     {
                                            //         columnConfig,
                                            //         dargname,
                                            //     },
                                            //     () => {
                                            //         this.pushToColumnConfig();
                                            //     }
                                            // );
                                        }
                                    }}
                                    onStop={(drag, list) => {
                                        if (list) {
                                            this.columnConfigFlag = false;
                                            columnConfig[0].name = list.map(
                                                (e) => e.props.name
                                            );
                                            columnConfig[0].code = list.map(
                                                (e) => e.props.code
                                            );

                                            let delIndex = drag.source.index;

                                            // if (
                                            //     drag.destination.index <
                                            //     this.addIndex
                                            // ) {
                                            //     columnConfig[0].name.splice(
                                            //         delIndex + 1,
                                            //         1
                                            //     );
                                            //     columnConfig[0].code.splice(
                                            //         delIndex + 1,
                                            //         1
                                            //     );
                                            // } else {
                                            //     columnConfig[0].name.splice(
                                            //         delIndex,
                                            //         1
                                            //     );
                                            //     columnConfig[0].code.splice(
                                            //         delIndex,
                                            //         1
                                            //     );
                                            // }
                                            console.log(columnConfig);

                                            this.setState({
                                                configNamesList: [
                                                    ...columnConfig[0].name,
                                                ],
                                                dragoverIndex: -1,
                                            });

                                            this.handleColumnConfig(
                                                columnConfig
                                            );
                                            this.props.pushToColumnConfig?.();
                                        }
                                    }}
                                    onDragUpdate={(overItem) => {
                                        let { destination, source } = overItem;
                                        if (destination && destination.index) {
                                            if (
                                                source &&
                                                (source.index ||
                                                    source.index === 0)
                                            ) {
                                                if (
                                                    source.index >=
                                                    destination.index
                                                ) {
                                                    this.setState({
                                                        dragoverIndex:
                                                            destination.index -
                                                            1,
                                                    });
                                                } else if (
                                                    source.index <
                                                    destination.index
                                                ) {
                                                    this.setState({
                                                        dragoverIndex:
                                                            destination.index,
                                                    });
                                                }
                                            }
                                        }
                                    }}
                                    fieldid="column-config_list"
                                />
                            </div>
                            <div className="refer-dnd-bottom">
                                <span
                                    className="to-default"
                                    onClick={() => {
                                        this.props.resetColumnConfig();
                                        setTimeout(() => {
                                            this.shezhi && this.shezhi.click();
                                        }, 50);
                                        this.setState({
                                            configNamesList: [],
                                            // closeColumn: false,
                                        });
                                    }}
                                >
                                    {/* 恢复默认 */}
                                    {jsonInsideRefer['containers-refer-0005']}
                                </span>
                            </div>
                        </div>
                    )
                }
            >
                <Tooltip
                    placement="top"
                    overlay={jsonInsideRefer['containers-refer-column-setting']}
                    delayHide={1}
                    delayShow={1000}
                >
                    <div
                        className={`${
                            refType === 'gridTree'
                                ? 'refer-column-config-gridTree'
                                : 'refer-column-config'
                        }`}
                        key="5"
                    >
                        <span
                            fieldid={getSysFieldid('shezhi_btn')}
                            ref={(dom) => {
                                this.shezhi = ReactDOM.findDOMNode(dom);
                            }}
                        >
                            <i
                                className="column-config iconfont icon-lbsz"
                                onClick={() => {
                                    // this.setState({
                                    //     showColumnConfigPop: true,
                                    // });
                                    // this.handleColumnConfigPop(true);

                                    this.setState({
                                        closeColumn: true,
                                    });
                                }}
                            />
                        </span>
                    </div>
                </Tooltip>
            </Popover>
        );
    }
}
